import { render } from "./MenteeList.vue?vue&type=template&id=e740e23c"
import script from "./MenteeList.vue?vue&type=script&lang=js"
export * from "./MenteeList.vue?vue&type=script&lang=js"

import exportComponent from "/home/parallels/Web/Repos/mentee-mentor/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__